import { DropzonePremium } from '@components'

import { Button, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { ReactComponent as IconBillUploadComponent } from '../../../../assets/images/dashboard-empty-state/bill-upload.svg'
import { emptyViewIconStyle } from '../styles/emptyIconStyles'

const FILES_ASIDE_WIDTH = '20%'

export const UploadsWidget = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`

export const FilesAside = styled.aside`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: ${FILES_ASIDE_WIDTH};
  height: 100%;
  margin-right: ${Spacing.S24};
  padding-top: ${Spacing.S24};
`

export const FileButton = styled(Button)`
  margin-top: ${Spacing.S8};
`

export const EmptyDropzone = styled(DropzonePremium)`
  width: 100%;
  height: 100%;
  margin-bottom: -${Spacing.S24};
`

export const IconBillUpload = styled(IconBillUploadComponent)`
  ${emptyViewIconStyle}
`
